export default __webpack_public_path__ + "static/media/Broadcast-white.720d0c47.svg";